import React from 'react';
import useCard from '../../Hooks/useCard';
import Card from './Card';



const CardContainer= () => {
    const {card}=useCard([]);

    return (
        <div className='container'>
            <div className="row row-cols-1 row-cols-md-3 g-4 justify-content-center">
            {
                card.map(card=><Card key={card.id} card={card}></Card>)
            }
            </div>
        </div>
    );
};

export default CardContainer;
